import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningFilled } from '@mint-lib/icons';
import { Illustration } from '@mint-lib/illustrations';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { getRouteApi } from '@mint/routing';
import isMobile from 'is-mobile';

import { ForbiddenErrorPageMobile } from './Mobile/ForbiddenErrorPageMobile.jsx';

const routeApi = getRouteApi('/_secured');

const ForbiddenErrorPage = () => {
  const { t } = useTranslation('@mint-lib/error-boundary');

  const navigate = routeApi.useNavigate();

  const handleNavigateToMyCampaigns = () => {
    navigate({ to: '/campaigns' });
  };

  if (isMobile()) {
    return <ForbiddenErrorPageMobile />;
  }

  return (
    <div className="m-auto my-0 flex h-200 flex-row items-center justify-center gap-16">
      <div className="inline-flex w-115 flex-col justify-center gap-8">
        <div className="flex flex-col items-start justify-start gap-4">
          <div className="flex flex-row items-center justify-center gap-2">
            <WarningFilled className="size-5 fill-error-main" />
            <p
              className={typographyVariants({
                variant: 'h3',
                color: 'error',
              })}
            >
              {t('403 Error')}
            </p>
          </div>

          <p
            className={typographyVariants({
              variant: 'h1',
              color: 'primary',
            })}
          >
            {t('Access Restricted')}
          </p>

          <div
            className={cn(
              'text-left',
              typographyVariants({
                variant: 'bodyLong01',
                color: 'primary',
              }),
            )}
          >
            <p>{t('Your user lacks the permissions to access this page.')}</p>
            <p>
              {t('Please contact your workspace administrator for assistance.')}
            </p>
          </div>
        </div>

        <Button
          onClick={handleNavigateToMyCampaigns}
          variant={'contained'}
          size="large"
          color="primary"
        >
          {t('Go to My Campaigns')}
        </Button>
      </div>
      <div className="flex items-center justify-center">
        <Illustration
          className="size-80"
          component={'IllustrationError403Light'}
        />
      </div>
    </div>
  );
};

export { ForbiddenErrorPage };
